import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Packages from "../components/Packages";
import CTABanner from "../components/CTABanner";

const PackagesPage = () => {
  return (
    <>
      <Header />
      <main>
        <section className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=1920&q=80"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/85 to-slate-900/50" />
          <div className="relative max-w-7xl mx-auto px-6 text-white">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur border border-white/20 text-white text-xs font-semibold tracking-wider uppercase">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-400" /> Tour Packages
            </div>
            <h1 className="mt-4 text-4xl md:text-6xl font-bold tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Handcrafted holidays for every mood
            </h1>
            <p className="mt-4 text-white/85 text-lg max-w-2xl">
              Compare, customise and book — 250+ tour packages across India starting at just ₹6,499.
            </p>
          </div>
        </section>
        <Packages />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
};

export default PackagesPage;
